(() => {
  if (customElements.get('mezuzah-sticky-atc')) return;

  const init = (bar) => {
    const root = document.getElementById(bar.dataset.mzsaRoot);
    const go = bar.querySelector('[data-mzsa-go]');
    const add = root && root.querySelector('button[name="add"]');
    if (!add || !go || !('IntersectionObserver' in window) || !('ResizeObserver' in window)) return;
    const buy = add.closest('.product__block--buttons') || add.closest('product-form') || add;
    const start = root.querySelector('.product__images') || root.querySelector('h1');
    // The Help Strip can sit in the Pre-footer group, outside <footer> (FOOTER-URLS-1027); the bar steps aside for it too.
    const footers = new Set(document.querySelectorAll('footer, .shopify-section-group-footer-group, [data-mzhs]'));
    const visibleFooters = new Set();
    const screen = window.matchMedia('(max-width: ' + (Number(bar.dataset.mzsaMaxWidth) - 1) + 'px)');
    const price = bar.querySelector('[data-mzsa-price]');
    const label = go.textContent.trim();
    const state = { buyIn: false, buyAbove: false, startIn: Boolean(start) };
    const page = document.documentElement;
    let action = null;
    let available = false;
    let height = 0;
    let shown = false;
    let pageHeight = 0;
    let pastObserver = null;

    const destination = () => {
      if (!available) return action;
      return [...root.querySelectorAll('[data-mz-cym-toggle]:not(:disabled)'), ...root.querySelectorAll('variant-selects input:not([type="hidden"]):not(:disabled), variant-selects select:not(:disabled)')]
        .find((node) => !node.closest('[hidden], [inert]')) || action;
    };

    const set = (on) => {
      if (on === shown) return;
      shown = on;
      if (!on && bar.contains(document.activeElement) && action) action.focus({ preventScroll: true });
      bar.classList.toggle('is-visible', on);
      bar.toggleAttribute('inert', !on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      page.classList.toggle('mzsa-active', on);
    };

    const update = () => {
      const clear = !state.buyIn && visibleFooters.size === 0;
      const position = bar.dataset.mzsaMode === 'after' ? state.buyAbove : !state.startIn;
      set(screen.matches && height > 0 && action !== null && clear && position);
    };

    const syncProduct = () => {
      const current = root.querySelector('button[name="add"]');
      available = Boolean(current && !current.disabled && current.dataset.mzVariantAvailable !== 'false');
      const notify = root.querySelector('[data-mezuzah-bis-pdp]');
      action = available ? current : bar.dataset.mzsaSoldOut === 'true' && notify && !notify.disabled && !notify.closest('[hidden], [inert]') ? notify : null;
      go.textContent = available || !action ? label : action.textContent.trim();
      go.setAttribute('aria-label', available || !action ? label : action.getAttribute('aria-label') || go.textContent);
      if (price) {
        const currentPrice = current && current.querySelector('.btn__price');
        const nativePrice = root.querySelector('[id^="Price-"] .price');
        const source = currentPrice || (nativePrice && nativePrice.querySelector(nativePrice.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular'));
        if (source && price.innerHTML !== source.innerHTML) price.replaceChildren(...Array.from(source.childNodes, (node) => node.cloneNode(true)));
      }
      update();
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === buy) {
          state.buyIn = entry.isIntersecting;
        } else if (entry.target === start) {
          state.startIn = entry.isIntersecting;
        } else if (footers.has(entry.target)) {
          if (entry.isIntersecting) visibleFooters.add(entry.target);
          else visibleFooters.delete(entry.target);
        }
      });
      update();
    });
    observer.observe(buy);
    if (start) observer.observe(start);
    footers.forEach((footer) => observer.observe(footer));

    const sizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const size = entry.borderBoxSize;
        const blockSize = size ? (size[0] || size).blockSize || 0 : 0;
        if (entry.target === bar) {
          height = blockSize;
          page.style.setProperty('--mzsa-height', height + 'px');
        } else if (blockSize > 0 && blockSize !== pageHeight) {
          pageHeight = blockSize;
          if (pastObserver) pastObserver.disconnect();
          pastObserver = new IntersectionObserver(([position]) => {
            state.buyAbove = !position.isIntersecting && position.boundingClientRect.bottom <= 0;
            update();
          }, { rootMargin: '0px 0px ' + pageHeight + 'px 0px' });
          pastObserver.observe(buy);
        }
      });
      update();
    });
    sizeObserver.observe(bar, { box: 'border-box' });
    sizeObserver.observe(page, { box: 'border-box' });

    const productObserver = new MutationObserver(syncProduct);
    const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'data-mz-variant-available', 'hidden'] };
    productObserver.observe(buy, options);
    const nativePrice = root.querySelector('[id^="Price-"]');
    if (nativePrice) productObserver.observe(nativePrice, options);

    const onClick = () => {
      syncProduct();
      const target = destination();
      if (!target) return;
      target.focus({ preventScroll: true });
      set(false);
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'instant' : 'smooth', block: 'center' });
    };
    go.addEventListener('click', onClick);
    screen.addEventListener('change', update);
    syncProduct();

    return () => {
      set(false);
      observer.disconnect();
      if (pastObserver) pastObserver.disconnect();
      sizeObserver.disconnect();
      productObserver.disconnect();
      go.removeEventListener('click', onClick);
      screen.removeEventListener('change', update);
      page.style.removeProperty('--mzsa-height');
    };
  };

  customElements.define('mezuzah-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected && !this.cleanup) this.cleanup = init(this);
      });
    }

    disconnectedCallback() {
      if (this.cleanup) this.cleanup();
      this.cleanup = null;
    }
  });
})();
